module.exports = __webpack_public_path__ + "img/historia19.9a554f6c.jpg";